import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { ReceptionStatusProviderDelayTimesQueryDocument } from '@docpace/reception-status-graphql/dist/urql.types'
import { ReceptionStatusProviderDelayTimesQueryResultFragment } from '@docpace/reception-status-graphql'

const typedReceptionStatusProviderDelayTimesQueryDocument = ReceptionStatusProviderDelayTimesQueryDocument as TypedDocumentNode<ReceptionStatusProviderDelayTimesQueryResultFragment>

export function useReceptionStatusProviderDelayTimesQuery(opts?: useQuery.Options<ReceptionStatusProviderDelayTimesQueryResultFragment>){
    return useQuery(typedReceptionStatusProviderDelayTimesQueryDocument, opts)
}
